import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Button } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'
import { Input, PlusBigIcon, SearchIcon } from '@root/shared/ui-kit'

import { assetsDrawerOpenAtom } from '../../atoms'

import type { WalletAssetsModel } from '../../atoms/reatom-wallet-assets'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  model: WalletAssetsModel
} & ClassNameProps

export const WalletAssetsSearch: React.FC<Props> = ({ className, model }) => {
  const { t } = useTranslation()
  const [searchQuery, setSearchQuery] = useAtom(model.searchQuery)
  const [_, setAssetsDrawerOpen] = useAtom(assetsDrawerOpenAtom)

  return (
    <Root className={className}>
      <InputAlt
        placeholder={t('common.search')}
        startContent={<SearchIcon size={16} color="var(--background-9)" />}
        size="m"
        value={searchQuery}
        onChange={(e) => {
          setSearchQuery(e.target.value)
        }}
      />
      <ButtonAdd
        radius="rounded"
        variant="secondary"
        onClick={() => {
          setAssetsDrawerOpen(true)
        }}
      >
        <PlusBigIcon size={14} />
        {t('common.add')}
      </ButtonAdd>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
`

const ButtonAdd = styled(Button)`
  --button-radius-rounded: 10px;

  border: 1px solid var(--backgroundA-7);
  color: var(--text-12);
  font-weight: 700;
`

const InputAlt = styled(Input)`
  hr {
    display: none;
  }
  label > div > div {
    gap: 0;
    margin-inline-end: 8px;
  }
`
